import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => css`
    text-align: center;

    font-weight: 300;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.dark_background};
    margin-top: auto;
    margin-bottom: 2rem;
    padding-top: 3rem;
  `}
`;
